import * as React from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { ChevronIcon } from '@icons';
import { getBrandFaqSection } from '@utils/get-brand-faq.ts';


import * as Styled from './faq.styled.ts';
import { getFaqData } from './get-faq-data.ts';

interface OpenItemsState {
	[key: number]: boolean;
}

type OwnProps = {
	isClosed?: boolean;
};

const Faq: React.FC<OwnProps> = ({ isClosed }) => {
	const [openItems, setOpenItems] = React.useState<OpenItemsState>({});

	const { t } = useTranslation('faq');

	const { hash } = useLocation();

	React.useEffect(() => {
		if (hash) {
			setTimeout(() => {
				const element = document.querySelector(hash);
				if (element) {
					element.scrollIntoView({ behavior: 'smooth' });
					setOpenItems(prevState => ({
						...prevState,
						[hash.slice(-1)]: true
					}));
				}
			}, 5);
		}
	}, [hash]);

	const faqData = getFaqData(t);
	const faqSection = getBrandFaqSection() as keyof ReturnType<typeof getFaqData>;

	const toggleAccordion = (id: number) => {
		setOpenItems((prevState: Record<number, boolean>) => ({
			...prevState,
			[id]: !prevState[id]
		}));
	};

	return (
		<Styled.Container>
			<Styled.Title>{t('faq_top')}</Styled.Title>
			{faqData[faqSection].map(item => (
				<Styled.Item key={item.id} id={item.anchor}>
					<Styled.Question $isClickable={isClosed} onClick={() => isClosed && toggleAccordion(item.id)}>
						<Styled.QuestionTitle>{item.question}</Styled.QuestionTitle>
						{isClosed && (
							<Styled.Arrow $isActive={openItems[item.id]}>
								<ChevronIcon />
							</Styled.Arrow>
						)}
					</Styled.Question>

					<Styled.Answer
						$isOpen={isClosed ? openItems[item.id] : true}
						dangerouslySetInnerHTML={{ __html: item.answer }}
					></Styled.Answer>
				</Styled.Item>
			))}
		</Styled.Container>
	);
};

export default Faq;
